import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { hideLoader } from '../../store/app/actions';
import { openScreenShotGallery } from '../../store/app/index';
import RecordingList from '../../components/RecordingList';
import ScreenshotList from '../../components/ScreenshotList';
import { ReactComponent as TickerMarkCircle } from '../../assets/img/tickmarkcircle.svg';
import './event-end.css';
import { EVENT_TYPE, FINAL_EVENT_STATUS } from '../../constants';

const POSTER_MODES = {
  IMG_PORTRAIT_3_4: 'img-portrait-3-4',
  IMG_PORTRAIT_9_16: 'img-portrait-9-16',
  IMG_LANDSCAPE: 'img-landscape',
};

const EventEnd = ({
  ctrl,
  hideLoader,
  title,
  desc,
  poster,
  recordingList,
  clientScreenshots,
  screenshotList,
  showMoments,
  sessionExpired,
  isSSSupport,
  recordingConfigFlag,
  pipMode,
  mode,
  eventStatus,
  headless,
  originalEventType,
}) => {
  const [posterImgMode, setPosterImgMode] = useState(POSTER_MODES.IMG_LANDSCAPE);

  useEffect(() => {
    setTimeout(() => {
      hideLoader();
    }, 100);
    //eslint-disable-next-line
  }, []);

  const checkRecordings = () => recordingList.length > 1 && recordingConfigFlag;

  const handlePosterImgLoad = (e) => {
    if (mode === 'landscape') return;
    const aspectRatio = (e.target.naturalWidth / e.target.naturalHeight).toFixed(2);
    if (aspectRatio < 0.6) {
      setPosterImgMode(POSTER_MODES.IMG_PORTRAIT_9_16);
    }
    if (aspectRatio > 0.6 && aspectRatio < 1) {
      setPosterImgMode(POSTER_MODES.IMG_PORTRAIT_3_4);
    }
    if (aspectRatio >= 1) {
      setPosterImgMode(POSTER_MODES.IMG_LANDSCAPE);
    }
  };
  const getClasses = (elemClassName) => {
    if (elemClassName.includes('eventEndPageContainer')) {
      let className = `eventEndPageContainer ${posterImgMode}`;
      if (screenshotList.length === 0 && !clientScreenshots) {
        className += ' noSS';
      }
      if (!recordingConfigFlag) {
        className += ' noRec';
      }
      return className;
    }
  };

  useEffect(() => {
    if (posterImgMode === POSTER_MODES.IMG_PORTRAIT_9_16 && !recordingConfigFlag) {
      document.getElementById('eventEndPageContainer').style.setProperty('--poster-img-height', `100vh`);
    }
    if (posterImgMode === POSTER_MODES.IMG_PORTRAIT_3_4) {
      document
        .getElementById('eventEndPageContainer')
        .style.setProperty('--poster-img-height', `${window.innerHeight - 200}px`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      {headless ? (
        <div className="headlessEndMsg">The Event has ended!</div>
      ) : (
        <>
          <div className={getClasses('eventEndPageContainer')} id="eventEndPageContainer">
            <div className="msgWrapper">
              <TickerMarkCircle />
              <p>
                {originalEventType === EVENT_TYPE.SIMULIVE && eventStatus !== FINAL_EVENT_STATUS.ENDED
                  ? 'Event has been stopped by host'
                  : 'The Event has ended!'}
              </p>
            </div>
            <div className="eventDetailWrapper">
              <div className="details">
                <div className="endNote">
                  <p className="title">{title}</p>
                  <p className="byline">{desc}</p>
                  {mode === 'landscape' && checkRecordings() ? (
                    <div className="multipleRec">
                      <RecordingList />
                    </div>
                  ) : null}
                </div>
              </div>
              {mode === 'portrait' && posterImgMode.includes('portrait') && checkRecordings() ? (
                <div className="multipleRec">
                  <RecordingList isPosterImgPortrait={posterImgMode.includes('portrait')} />
                </div>
              ) : null}
              <div className="poster">
                {recordingList.length === 1 && recordingConfigFlag ? (
                  <RecordingList />
                ) : (
                  <img onLoad={handlePosterImgLoad} src={poster} alt="event-poster" />
                )}
              </div>
            </div>
            {mode === 'portrait' && posterImgMode === POSTER_MODES.IMG_LANDSCAPE && checkRecordings() ? (
              <div className="multipleRec">
                <RecordingList />
              </div>
            ) : null}
            {!pipMode && isSSSupport && <ScreenshotList />}
          </div>
          <div id="preview"></div>
          <div className={'bgLayer'} id="bgLayer"></div>
        </>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    mode: state.app.mode,
    title: state.app.title,
    screenshotList: state.app.screenshotList,
    desc: state.app.desc,
    clientScreenshots: state.app.clientScreenshots,
    screenshot: state.app.screenshot,
    recordingList: state.app.recordingList,
    sessionExpired: state.app.sessionExpired,
    isSSSupport: state.app.config.screenshot,
    recordingConfigFlag: state.app.apiJsonConfig.showRec,
    pipMode: state.app.pipMode,
    showMoments: state.app.apiKeyJson.conf?.endScreen?.showMoments,
    eventStatus: state.app.eventStatus,
    headless: state.app.config.headless,
    originalEventType: state.app.originalEventType,
  };
};

const mapDispatchToProps = {
  hideLoader,
  openScreenShotGallery,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventEnd);
